// extracted by mini-css-extract-plugin
export default {"label":"RichTextField_label__b-2M5","editor":"RichTextField_editor__IHMLD","btn":"RichTextField_btn__Z6AbZ"};